import { Urls } from "../../utils/endPoints/apiUrls";
import { apiRequest } from "../../utils/comman/apiRequest";

export const fetchFlashData = async (page = 1, itemsPerPage = 10, filters = {}) => {
  try {
    // Start with base query parameters
    const baseParams = {
      page,
      limit: itemsPerPage,
    };
    
    // Build URL with query string manually
    let queryString = Object.entries(baseParams)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
    
    // Add filters if they exist
    if (Object.keys(filters).length > 0) {
      const filterParams = Object.entries(filters)
        .filter(([_, value]) => value !== undefined && value !== null && value !== '')
        .map(([key, value]) => {
          // Handle arrays specifically (like selectedMaterials might be an array)
          if (Array.isArray(value)) {
            // If it's an array that should be comma-separated
            return `${encodeURIComponent(key)}=${encodeURIComponent(value.join(','))}`;
            
          }
          return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        })
        .join('&');
      
      if (filterParams) {
        queryString = queryString ? `${queryString}&${filterParams}` : filterParams;
      }
    }
    
    
    const response = await apiRequest({
      endUrl: `${Urls.flashdashboard}?${queryString}`,
      method: "GET",
    });
   
    if (response.status == true) {
      
      return {
        success: true,
        data: response.data,
      };
    } else {
      throw new Error(response.message || "Failed to fetch data");
    }

   
  } catch (error) {
    console.error("Error in fetchFlashData:", error);
    return { success: false, error: error.message };
  }
};